import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class MinLengthValidationMessageResolver implements ValidationMessageResolver<{ requiredLength: unknown }> {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = 'minlength';

  getMessage(error?: { requiredLength: unknown }): string {
    return this.translateService.instant('label.validation.minLength.value', { value: error?.requiredLength });
  }
}
